import { forwardRef, type ComponentProps } from 'react';
import { MoneyInput } from '../../atoms/money-input.component';
import { FieldLayoutWithAction } from '../../layouts/field-layout-with-action';
import type { BasicFormFieldProps, ExtraFieldProps, FieldActionProps } from '../../layouts/types';

type Props = BasicFormFieldProps<'money'> & ExtraFieldProps & FieldActionProps;

export const MoneyField = forwardRef<HTMLDivElement, Props>((props, ref) => (
  <FieldLayoutWithAction
    {...props}
    //TODO: this might be able to be improved. But this type cast just makes sure the field prop is any of the correct field types
    field={MoneyInput as ComponentProps<typeof FieldLayoutWithAction>['field']}
    ref={ref}
  />
));

MoneyField.displayName = 'MoneyField';
